module.exports = __webpack_public_path__ + "media/images/about-us/youtube-afe026a19bb206ba20a651449825f995.svg";